import React from 'react';
import moment from 'moment';

import { Link } from 'react-router';

function renderContent({ child, value }) {
	return (
		<Link to={`/banners/contents/${value.id}/editor`}>{child}</Link>
	);
}

function renderActions(_, { row }) {
	return (
		<div>
			<Link
				className='banners-edit-icon'
				to={`/banners/publications/${row.id}/editor`}
			/>
		</div>
	);
}

export default [
	[
		{
			index: 'title',
			header: {
				title: 'title'
			},
			column: {}
		},
		{
			index: 'campaign',
			header: {
				title: 'campaign'
			},
			column: {
				format: v => v.title
			}
		},
		{
			index: 'content',
			header: {
				title: 'content'
			},
			column: {
				format: v => v.title,
				render: renderContent
			}
		},
		{
			index: 'clicks',
			header: {
				title: 'clicks'
			},
			column: {}
		},
		{
			index: 'display_at',
			header: {
				title: 'display at'
			},
			column: {
				format: v => moment(v).format('DD.MM.YYYY HH:mm')
			}
		},
		{
			index: 'created_at',
			header: {
				title: 'created at'
			},
			column: {
				format: v => moment(v).format('DD.MM.YYYY HH:mm')
			}
		},
		{
			index: 'actions',
			header: {
				title: 'actions'
			},
			column: {
				render: renderActions
			}
		}
	]
];


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/banners/publication/list/table-initial-data.js